import type { WidgetPreset } from "../types";
import templateHtml from "./template.html?raw";

export const SPEECH_BUBBLE: WidgetPreset = {
  id: "speech-bubble",
  label: "Hmm… 💭",
  defaultWidth: 230,
  defaultHeight: 86,
  html: templateHtml,
};
